import * as React from "react";
import { useI18n } from "@app/providers/i18n";
import { Languages } from "lucide-react";

export function LanguageSwitcher({ className }: { className?: string }) {
  const { t, lang, setLang, supported } = useI18n();
  const onChange: React.ChangeEventHandler<HTMLSelectElement> = (e) =>
    setLang(e.target.value as any);
  const labels: Record<string, string> = {
    en: t("english"),
    ar: t("arabic"),
    tr: t("turkish"),
  };
  return (
    <label
      className={`relative inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-md border bg-background hover:bg-primary/10 lg:h-auto lg:w-auto lg:border-0 lg:bg-transparent ${className ?? ""}`}
    >
      <Languages className="h-4 w-4 lg:hidden" aria-hidden="true" />
      <span
        className="absolute bottom-0.5 right-1 text-[8px] font-bold uppercase leading-none lg:hidden"
        aria-hidden="true"
      >
        {lang}
      </span>
      <select
        aria-label={t("language")}
        value={lang}
        onChange={onChange}
        className="absolute inset-0 h-full w-full cursor-pointer opacity-0 lg:static lg:h-auto lg:w-auto lg:rounded-md lg:border lg:bg-background lg:text-foreground lg:px-2 lg:py-1 lg:text-sm lg:opacity-100"
      >
        {supported.map((l) => (
          <option key={l} value={l}>
            {labels[l] ?? l}
          </option>
        ))}
      </select>
    </label>
  );
}
